import {
  MainContainer,
  MainContainerWrap,
  SubTitle,
} from "../../styled-components/utils/containerStyles";
import {
  ContactBody,
  ContactData,
  ContactDetails,
  ContactItem,
} from "../contact/contactStyles";
import InternshipForm from "./InternshipForm";

const infoSection = () => {
  return (
    <MainContainerWrap half>
      <MainContainer
        style={{
          alignItems: "flex-start",
          color: "black",
          margin: "80px 0",
        }}
      >
        <ContactData>
          <div>
            <SubTitle style={{ marginBottom: "30px" }}>Opportunities</SubTitle>
            <ContactDetails>
              {/* todo: move up */}
              <ContactBody noStyle={true}>
                <ContactItem bold={true}>Associate</ContactItem>
                <ContactItem bold={true}>Internship</ContactItem>
                <ul style={{ listStyle: "inside", marginLeft: "15px" }}>
                  <li style={{ fontSize: "1rem" }}>Online</li>
                  <li style={{ fontSize: "1rem" }}>Offline</li>
                </ul>
                <ContactItem bold={true}>Other</ContactItem>
              </ContactBody>
            </ContactDetails>
          </div>
        </ContactData>
        <InternshipForm />
      </MainContainer>
    </MainContainerWrap>
  );
};

export default infoSection;
